import i18n from 'i18next'
import detector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEN from '../../public/locales/en.json'
import translationFR from '../../public/locales/fr.json'

export const LOCALES = ['fr', 'en']
export const DEFAULT_LOCALE = 'fr'

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
}

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES,
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  })

export default i18n
